import React from "react"
import PropTypes from "prop-types"
import { SiteSettingsSection } from "../constants"
import { SettingsCardContent } from "@modules/site/settings"
import SiteSettingsSectionCard from "./SiteSettingsSectionCard"
import { useApolloFragment } from "apollo-fragment-react"
import IncrementalBuildsSettings from "./IncrementalBuildsSettings"

const siteDataFragment = `
  fragment ExperimentalFeaturesSiteFragment on Site {
    incrementalBuildsEnabled
  }
`

const propTypes = {
  siteId: PropTypes.string.isRequired,
}

export default function ExperimentalFeaturesSection({ siteId }) {
  const { data: siteData } = useApolloFragment(siteDataFragment, siteId)

  if (!siteData) {
    return null
  }

  return (
    <SiteSettingsSectionCard id={SiteSettingsSection.ExperimentalFeatures}>
      <SettingsCardContent>
        <IncrementalBuildsSettings
          siteId={siteId}
          incrementalBuildsEnabled={siteData.incrementalBuildsEnabled}
        />
      </SettingsCardContent>
    </SiteSettingsSectionCard>
  )
}

ExperimentalFeaturesSection.propTypes = propTypes
